/**
 * Implements a CR project creation screen.
 */

import Radio from "backbone.radio";
import GenericModal from "../../../generic/modal/base";
import KeyValueStringCollection from "../../../../collections/key-string-value";
import UserCollection from "../../../../collections/chart-reviews/reviewers/selectable";
import Form from "./form";
import AnalyticsBehavior from "../../../../behaviors/analytics";
import environment from "../../../../common/environment";

const channel = Radio.channel("global");

const STATUSES = [
  { key: "OPEN", value: "Open", checked: true },
  { key: "CLOSED", value: "Closed" },
];

const DEFAULTS = {
  // TODO remove this when the boostrap-select behavior is implemented
  className: "modal-md",
  returnRoute: "chart-reviews.projects",
  returnRouteRefresh: true,
  title: "Create a Chart Review Project",
};

class AddProject extends GenericModal {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  behaviors() {
    return [
      {
        behaviorClass: AnalyticsBehavior,
        opts: {
          title: this.options.title || null,
        },
      },
    ];
  }

  // @Override
  onBeforeRender() {
    // Fetch setup data
    this._setup();

    // call superclass
    if (super.onBeforeRender) super.onBeforeRender();
  }

  _setup() {
    // fetch full profiles for managers and reviewers
    $.when(
      $.ajax(environment.getEndpoint("managers")),
      $.ajax(environment.getEndpoint("reviewers"))
    ).then(this._onSetupLoad.bind(this), this._onSetupLoadFailure.bind(this));
  }

  _onSetupLoad(managers, reviewers) {
    // update model
    this.model.set({
      managers: new UserCollection(managers[0]),
      reviewers: new UserCollection(reviewers[0]),
      statuses: new KeyValueStringCollection(STATUSES),
    });

    this._show();
  }

  _onSetupLoadFailure() {
    // dismiss modal
    this._hide();

    // display error message
    channel.trigger("status:show", {
      autoDismiss: false,
      type: "danger",
      message:
        "We were unable to retrieve all the data necessary for this activity. Please try again later.",
    });
  }

  _show() {
    this.body.show(
      new Form({
        model: this.model,
      })
    );
  }
}

export { AddProject as default };
